/** Reloads the app so it fetches the files of the current deployment. */
export function reloadPage() {
  window.location.reload()
}
